import React from 'react';

import { NavLink, useLocation } from 'react-router-dom';
import { useQuery } from 'react-query';

import classes from './styles.module.scss';
import UserService from '../../services/UserService';
import { isTrainingPathsEnabledForOrg } from '../../constants/main';

export default function Navigation() {
  const location = useLocation();
  const { data: currentUser } = useQuery('me', UserService.getMe);

  const isMeetingEditing = location.pathname.includes('/edit');
  const isMeetingHistory = location.pathname.includes('/history');

  const isTrainingPathsEnabled = isTrainingPathsEnabledForOrg(currentUser);

  return (
    <nav className={classes.Navigation}>
      <div className={classes.linksContainer}>
        <NavLink
          className={({ isActive }) =>
            (isActive && !isMeetingEditing && !isMeetingHistory) ? classes.active : undefined
          }
          to="/my-videos"
        >
          My Videos
        </NavLink>

        {isTrainingPathsEnabled && (
          <NavLink
            className={({ isActive }) => (isActive ? classes.active : undefined)}
            to="/training-paths"
          >
            Training Paths
          </NavLink>
        )}

        <NavLink
          className={({ isActive }) => (isActive ? classes.active : undefined)}
          to="/my-library"
        >
          My Library
        </NavLink>
      </div>
    </nav>
  );
}
